import { Info } from '../../types/localeTypes';

export const info: Info = {
  da: {
    address: 'Amaliegade 45, Mezzanin 1256 København K',
    email: 'kundeservice@dreamplan.io',
    phone: '+ 45 2613 6195',
    followText: 'Følg os på:',
  },
  en: {
    address: 'Amaliegade 45, Mezzanin 1256 Copenhagen, Denmark',
    email: 'customerservice@dreamplan.io',
    phone: `+ 45 2613 6195`,
    followText: 'Follow us on:',
  },
  es: {
    address: 'Amaliegade 45, Mezzanin 1256 Copenhague, Dinamarca',
    email: 'customerservice@dreamplan.io',
    phone: '+ 45 2613 6195',
    followText: 'Síguenos en:',
  },
  no: {
    address: 'Amaliegade 45, Mezzanin 1256 København K, Danmark',
    email: 'customerservice@dreamplan.io',
    phone: '+ 45 2613 6195',
    followText: 'Følg oss på:',
  },
};
